module.exports = __webpack_public_path__ + "static/Dafiti2-cc2831535242dd0a33ff7fe2a50b5a8e.png";